<template>
    <v-app class="content" :style="themeStyle">
        <console-app-bar v-model="drawer" :title="title" color="app-bar"></console-app-bar>
        <console-drawer v-model="drawer"></console-drawer>

        <v-content>
            <v-container fluid fill-height class="pa-0">
                <slot />
            </v-container>
        </v-content>
    </v-app>
</template>

<script>
////////////////////////////////////////////////////////////////////////////////
// 콘솔 UI 관련 컴포넌트
////////////////////////////////////////////////////////////////////////////////
import ConsoleAppBar from './console-app-bar.vue';
import ConsoleDrawer from './console-drawer.vue';

export default {
    props: {
        title: { type: String, default: "관리자" }
    },
    components: {
        ////////////////////////////////////////////////////////////////////////////////
        // 콘솔 UI 관련 컴포넌트
        ////////////////////////////////////////////////////////////////////////////////
        ConsoleAppBar,
        ConsoleDrawer,
    },
    data: () => {
        return {
            drawer: null,
        };
    },
    computed: {
        themeStyle(){
            return {
                background: this.$vuetify.theme.themes[this.$vuetify.theme.isDark ? "dark" : "light"].content
            };
        },
        isDark(){
            return this.$vuetify.theme.isDark;
        }
    }
}
</script>
